<ul *ngIf="showActions()">
  <!-- CHAT BOX LINK -->
  <li>
    <button mat-icon-button type="button" class="cng-ico_chat2" (click)="goToChatBox()" [class.active]="isChatSelected()"></button>
  </li>

  <!-- CHAT QUALIF LINK -->
  <li>
    <button
      mat-icon-button
      type="button"
      class="cng-ico_edit_doc"
      (click)="goToQualification()"
      [class.active]="isQualificationSelected()"
      [disabled]="!isPostTreatmentEnabled()"
    ></button>
  </li>
</ul>
